import { render, staticRenderFns } from "./CreateServer.vue?vue&type=template&id=12f06dd5&scoped=true&"
import script from "./CreateServer.vue?vue&type=script&lang=js&"
export * from "./CreateServer.vue?vue&type=script&lang=js&"
import style0 from "./CreateServer.vue?vue&type=style&index=0&id=12f06dd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f06dd5",
  null
  
)

export default component.exports